import { Box, LinearProgress, Typography } from '@mui/material'
import { FunctionComponent } from 'react'

export const ImportStepHeader: FunctionComponent<{
  currentStep: number
  totalSteps?: number
}> = ({
  currentStep,
  totalSteps = 4,
}) => {
  const safeStep = Math.max(1, Math.min(currentStep, totalSteps))

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="overline" sx={{ display: 'block', mb: 1, color: 'text.secondary', letterSpacing: 1 }}>
        Step {safeStep} of {totalSteps}
      </Typography>
      <LinearProgress
        variant="determinate"
        value={(safeStep / totalSteps) * 100}
        sx={{
          height: 5,
          borderRadius: 4,
          backgroundColor: 'lightGrey.main',
          '& .MuiLinearProgress-bar': {
            borderRadius: 4,
          }
        }}
      />
    </Box>
  )
}
